import LoginRegisterTransferLink from '@map/components/GuestArea/LoginRegisterTransferLink';
import { FormPasswordField, FormTextField } from '@map/components/formControls/controlled';
import { useUpdateAuthenticationFlow } from '@map/hooks/flows/authentication';
import { CreateUserInput } from '@map/hooks/userApi';
import { windowExtended } from '@map/types';
import { userValidationSchema } from '@map/validators/user';
import { Typography } from '@mui/material';
import { useFormatMessage } from '@shared/hooks/intl';
import { Form } from '@shared/lib/form';
import { SubmitButton, type SubmitFunction } from '@shared/lib/form/Form';
import { useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import PublicPage from '../../shared/PublicPage';
import PhoneEmailTransferButton from '../PhoneEmailTransferButton';
import { useRegistrationContext } from '../context';

const pluckedValidationSchema = userValidationSchema.pick(['email', 'password']);

const Email = () => {
  const { submit } = useRegistrationContext();
  const updateAuthenticationFlow = useUpdateAuthenticationFlow();
  updateAuthenticationFlow({ method: 'email' });
  const t = useFormatMessage();
  const handleSubmit = useCallback<SubmitFunction<Pick<CreateUserInput, 'email' | 'password'>>>(
    async (values, { setFieldError }) => {
      const result = await submit(values);
      if ((result as { success: boolean; error?: string }).error === 'email_taken') {
        // i18n-tasks-use t('registration.email_already_used')
        setFieldError('email', 'registration.email_already_used');
      }
    },
    [submit],
  );

  return (
    <PublicPage
      title={<FormattedMessage id="registration.sign_up_button" />}
      footer={<LoginRegisterTransferLink to="login" variant="minimal" />}
    >
      <Form
        initialValues={{
          email: windowExtended.invitation?.email || '',
          password: '',
        }}
        validationSchema={pluckedValidationSchema}
        onSubmit={handleSubmit}
      >
        <FormTextField
          name="email"
          type="email"
          autoComplete="email"
          placeholder={t('login.email_label')}
          autoFocus
        />
        <FormPasswordField
          placeholder={t('registration.password_label')}
          name="password"
          autoComplete="new-password"
          helperText={
            <Typography variant="body3" color="neutrals.600">
              <FormattedMessage id="registration.password_helper" />
            </Typography>
          }
        />

        <SubmitButton fullWidth={true} size="medium">
          <FormattedMessage id="registration.next" />
        </SubmitButton>
        <PhoneEmailTransferButton to="phone" />
      </Form>
    </PublicPage>
  );
};

export default Email;
